import automations from './Automations.aspx.he.json';
import campaigns from './Campaigns.aspx.he.json';
import common from './Common.he.json';
import landingPages from './LandingPages.aspx.he.json';
import mms from './MmsCampaigns.aspx.he.json';
import sms from './SMSCampaigns.aspx.he.json';
import master from './Pulseem.master.he.json';
import appBar from './AppBar.he.json';
import notifications from './Notifications.he.json';
import mainReport from './MainReport.aspx.he.json';
import dashboard from './Dashboard.he.json';
import smsReport from './SMSReport.he.json';
import report from './Reports.he.json';
import emailStatus from './EmailStatus.he.json';
import emoji from './Emoji.he.json';
import payment from './payment.he.json';
import siteTracking from './SiteTracking.he.json';
import client from './Client.he.json';
import recipient from './Recipient.json';
import group from './group.json';
import mmsreport from './MMSReport.he.json';
import languages from './languages.he.json';
import whatsapp from './WhatsappCreator.json';
import whatsappCampaign from './WhatsappCampaign.json';
import whatsappManagement from './WhatsappManagement.json';
import whatsappReport from './WhatsappReport.json';
import whatsappChat from './WhatsappChat.json';
import settings from './Settings.he.json';
import integrations from './Integrations.he.json';
import WhatsappApiResponse from './WhatsappApiResponse.json';
import SignUp from './SignUp.json';
import SimplyClub from './WhiteLabel/SimplyClub.he.json';
import FileUploads from './FileUploads.he.json';
import affiliate from './Affiliate.he.json';
import SubAccount from './SubAccount.he.json';
import billing from './Billing.he.json';
import TermsOfUse from './TermsOfUse.he.json'
import SubUsers from './SubUsers.he.json'
import WhatsappOnBoarding from './WhatsappOnBoarding.json';
import AI from './AI.he.json';
import colorPalette from './colorPalette.he.json'
import AILoader from './AILoader.he.json'
import RemoveMyData from './RemoveMyData.json';
import PopupTriggers from './PopupTriggers.json';
import Popup from './Popup.he.json';
import DataSources from './DataSources.he.json';
import SendSearch from './SendSearch.he.json';
import ClalCenter from './ClalCenter.he.json';

export const he = {
	PopupTriggers,
	automations,
	campaigns,
	common,
	landingPages,
	mms,
	sms,
	appBar,
	master,
	notifications,
	mainReport,
	dashboard,
	smsReport,
	report,
	emailStatus,
	emoji,
	payment,
	siteTracking,
	client,
	recipient,
	group,
	mmsreport,
	languages,
	settings,
	whatsapp,
	whatsappCampaign,
	whatsappManagement,
	whatsappReport,
	whatsappChat,
	integrations,
	WhatsappApiResponse,
	SignUp,
	FileUploads,
	SimplyClub,
	affiliate,
	SubAccount,
	billing,
	TermsOfUse,
	SubUsers,
	WhatsappOnBoarding,
	AI,
	colorPalette,
	AILoader,
	RemoveMyData,
	Popup,
	DataSources,
	SendSearch,
	ClalCenter
};
